export const Logo = ({ showText, height = 20 }: { showText: boolean; height?: number }) => {
  return (
    <svg
      viewBox={showText ? "0 0 377 94" : "0 0 87 94"}
      style={{ width: "auto", height: `${height}px` }}
      aria-labelledby="logo-title"
    >
      <title id="logo-title">Draftit logo</title>
      <defs>
        <path id="a" d="M0 0h377v94H0V0Z" />
        <path id="b" d="M0 93.426h376.789V0H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use xlinkHref="#a" fill="transparent" />
        <g>
          {showText && (
            <>
              <path
                fill="currentColor"
                d="M118.4 82.004V9.923h21.624c20.022 0 33.038 10.51 33.038 36.04s-13.016 36.04-33.038 36.04H118.4Zm9.61-8.61h12.014c14.767 0 23.426-6.608 23.426-27.431 0-20.824-8.659-27.432-23.426-27.432H128.01v54.863ZM180.647 82.004v-52.06h9.01v7.009c0 .499.201.7.702.7.6 0 .801-.301 1-.8 2.302-5.006 5.907-7.11 13.016-7.11h5.806v8.81h-7.209c-8.709 0-13.315 3.905-13.315 13.917v29.534h-9.01ZM229.527 51.568l19.023-.8v-2.803c0-7.41-3.805-11.713-13.016-11.713-9.21 0-12.915 4.303-13.116 9.71h-9.309c.4-9.91 7.408-17.52 22.425-17.52s21.725 7.61 21.725 20.023v33.54h-8.61v-5.509c0-.399-.2-.6-.6-.6-.4 0-.6.101-1.002.6-3.705 4.957-9.21 7.01-16.018 7.01-13.015 0-20.523-6.809-20.523-16.82 0-9.01 6.007-14.567 19.021-15.118m2.503 24.128c10.011 0 16.52-5.707 16.52-16.718v-.602l-19.023.801c-7.007.301-10.01 3.003-10.01 7.51 0 5.506 4.503 9.01 12.513 9.01"
              />
              <mask id="c" fill="#fff">
                <use xlinkHref="#b" />
              </mask>
              <path
                fill="currentColor"
                d="M328.66 21.935h9.01V9.921h-9.01v12.014Zm0 60.07h9.01v-52.06h-9.01v52.06ZM340.748 37.953v-8.01h12.014V15.929h9.01v14.014h15.017v8.01h-15.017v34.54c0 .5.099.801.4 1.102.301.299.602.4 1.102.4H376.789v8.008h-9.01c-10.162 0-15.017-4.855-15.017-15.017V37.953h-12.014Z"
                mask="url(#c)"
              />
              <path
                fill="currentColor"
                d="M325.355 37.949v-8.01h-15.02v-14.01h-9.01v14.01h-27.09v-10.51c0-.5.1-.8.4-1.1.3-.3.6-.4 1.1-.4h16.02v-8.01h-10.01c-11.12 0-16.52 5.36-16.52 16.52v55.57h9.01V37.949h27.09v29.04c0 10.16 4.86 15.01 15.02 15.01h9.01v-8h-13.52c-.5 0-.8-.1-1.1-.4-.3-.3-.4-.61-.4-1.11v-34.54h15.02Z"
                mask="url(#c)"
              />
            </>
          )}
          <path
            fill="currentColor"
            d="M37.707 26.267V0h10.756v36.206c0 .102 0 .415.36.623.36.209.63.052.72 0l31.355-18.103 5.378 9.316-22.747 13.133a17.214 17.214 0 0 1-25.822-14.908M37.707 67.16v26.267h10.756V57.22c0-.102 0-.415.36-.623a.666.666 0 0 1 .72 0L80.898 74.7l5.378-9.316-22.747-13.133A17.214 17.214 0 0 0 37.707 67.16M28.126 31.744 5.378 18.611 0 27.926 31.355 46.03a.67.67 0 0 1 .36.623.666.666 0 0 1-.36.623L0 65.378l5.378 9.315L28.126 61.56a17.214 17.214 0 0 0 0-29.816"
            mask="url(#c)"
          />
        </g>
      </g>
    </svg>
  );
};
